/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AbpPtwExceptionHttpResponseModel,
  CreateOrUpdateProtocolDto,
  HistoryDto,
  ODataPostProcessedResultsOfProtocolDto,
  ProtocolDto,
} from '../models/index';
import {
    AbpPtwExceptionHttpResponseModelFromJSON,
    AbpPtwExceptionHttpResponseModelToJSON,
    CreateOrUpdateProtocolDtoFromJSON,
    CreateOrUpdateProtocolDtoToJSON,
    HistoryDtoFromJSON,
    HistoryDtoToJSON,
    ODataPostProcessedResultsOfProtocolDtoFromJSON,
    ODataPostProcessedResultsOfProtocolDtoToJSON,
    ProtocolDtoFromJSON,
    ProtocolDtoToJSON,
} from '../models/index';

export interface CreateProtocolRequest {
    createOrUpdateProtocolDto?: CreateOrUpdateProtocolDto;
}

export interface DeleteProtocolRequest {
    id: string;
}

export interface GetProtocolRequest {
    id: string;
}

export interface GetProtocolHistoryRequest {
    id: string;
}

export interface GetProtocolListRequest {
    $filter?: string;
    $search?: string;
    $top?: number;
    $skip?: number;
    $orderby?: string;
}

export interface UpdateProtocolRequest {
    id: string;
    createOrUpdateProtocolDto?: CreateOrUpdateProtocolDto;
}

export interface ValidateProtocolRequest {
    createOrUpdateProtocolDto?: CreateOrUpdateProtocolDto;
}

/**
 * 
 */
export class ProtocolsApi extends runtime.BaseAPI {

    /**
     * Adds a new entity
     */
    async createProtocolRaw(requestParameters: CreateProtocolRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProtocolDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/protocols`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdateProtocolDtoToJSON(requestParameters.createOrUpdateProtocolDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => ProtocolDtoFromJSON(jsonValue));
    }

    /**
     * Adds a new entity
     */
    async createProtocol(requestParameters: CreateProtocolRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.createProtocolRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<ProtocolDto>(response, errorHandlers);
    }

    /**
     * Deletes the entity with the given id.
     */
    async deleteProtocolRaw(requestParameters: DeleteProtocolRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteProtocol.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/protocols/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes the entity with the given id.
     */
    async deleteProtocol(requestParameters: DeleteProtocolRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.deleteProtocolRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     * Returns one entity for detail view.
     */
    async getProtocolRaw(requestParameters: GetProtocolRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProtocolDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProtocol.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/protocols/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => ProtocolDtoFromJSON(jsonValue));
    }

    /**
     * Returns one entity for detail view.
     */
    async getProtocol(requestParameters: GetProtocolRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getProtocolRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<ProtocolDto>(response, errorHandlers);
    }

    /**
     */
    async getProtocolCatalogRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProtocolDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/protocols/catalog`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProtocolDtoFromJSON));
    }

    /**
     */
    async getProtocolCatalog(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getProtocolCatalogRaw(initOverrides);
        return this.configuration.handleFunction<Array<ProtocolDto>>(response, errorHandlers);
    }

    /**
     */
    async getProtocolHistoryRaw(requestParameters: GetProtocolHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HistoryDto>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProtocolHistory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/protocols/{id}/history`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HistoryDtoFromJSON));
    }

    /**
     */
    async getProtocolHistory(requestParameters: GetProtocolHistoryRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getProtocolHistoryRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<Array<HistoryDto>>(response, errorHandlers);
    }

    /**
     * Returns a list of entities for grid view.
     */
    async getProtocolListRaw(requestParameters: GetProtocolListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ODataPostProcessedResultsOfProtocolDto>> {
        const queryParameters: any = {};

        if (requestParameters.$filter !== undefined) {
            queryParameters['$filter'] = requestParameters.$filter;
        }

        if (requestParameters.$search !== undefined) {
            queryParameters['$search'] = requestParameters.$search;
        }

        if (requestParameters.$top !== undefined) {
            queryParameters['$top'] = requestParameters.$top;
        }

        if (requestParameters.$skip !== undefined) {
            queryParameters['$skip'] = requestParameters.$skip;
        }

        if (requestParameters.$orderby !== undefined) {
            queryParameters['$orderby'] = requestParameters.$orderby;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/protocols`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfProtocolDtoFromJSON(jsonValue));
    }

    /**
     * Returns a list of entities for grid view.
     */
    async getProtocolList(requestParameters: GetProtocolListRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getProtocolListRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<ODataPostProcessedResultsOfProtocolDto>(response, errorHandlers);
    }

    /**
     * Updates an entity, if existing
     */
    async updateProtocolRaw(requestParameters: UpdateProtocolRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProtocolDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateProtocol.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/protocols/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdateProtocolDtoToJSON(requestParameters.createOrUpdateProtocolDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => ProtocolDtoFromJSON(jsonValue));
    }

    /**
     * Updates an entity, if existing
     */
    async updateProtocol(requestParameters: UpdateProtocolRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.updateProtocolRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<ProtocolDto>(response, errorHandlers);
    }

    /**
     * Validates an entity without adding or updating it.
     */
    async validateProtocolRaw(requestParameters: ValidateProtocolRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/protocols/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdateProtocolDtoToJSON(requestParameters.createOrUpdateProtocolDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validates an entity without adding or updating it.
     */
    async validateProtocol(requestParameters: ValidateProtocolRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.validateProtocolRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

}
